import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {StatesService} from '../../../shared/services/state/states.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-manual-en',
    templateUrl: './manual-en.component.html',
    styleUrls: ['./manual-en.component.css']
})
export class ManualEnComponent implements OnInit, OnDestroy {

    public reloadIfLanguageChanged: Subscription;

    constructor(private statesService: StatesService,
                public router: Router,
                private translateService: TranslateService) {
    }

    ngOnInit() {
        this.reloadIfLanguageChanged = this.statesService.languageChanged.subscribe(() => {
            this.router.navigate(['/manual-' + this.translateService.currentLang.toString()]);

        });
    }

    ngOnDestroy(): void {
        this.reloadIfLanguageChanged.unsubscribe();
    }

}
